import React, { useRef, useState } from 'react';
import { Input, Button } from 'antd';
import { DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import {
  FormContainer,
  FormItemContainer,
  FormLabel as StyledFormLabel,
  FullWidthInputNumber,
  ImagePreviewBox,
  ImageButtonsRow,
  PreviewImg,
  HiddenFileInput,
} from '../Styles';
import { OptionFormProps } from '../types';
import ImageCropModal from '../../../../commonComponents/ImageCropModal';

export const OptionForm: React.FC<OptionFormProps> = ({
  newOptionData,
  handleNewOptionDataChange,
  existingPicture,
  onImageFileChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [localPreview, setLocalPreview] = useState<string | null>(existingPicture ?? null);
  const [cropSrc, setCropSrc] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (fileInputRef.current) fileInputRef.current.value = '';
    setCropSrc(URL.createObjectURL(file));
  };

  const handleCropDone = (file: File, previewUrl: string) => {
    setCropSrc(null);
    setLocalPreview(previewUrl);
    onImageFileChange(file);
  };

  const handleCropCancel = () => {
    setCropSrc(null);
  };

  const handleRemoveImage = () => {
    setLocalPreview(null);
    onImageFileChange(null);
  };

  return (
    <>
      <FormContainer>
        <FormItemContainer>
          <StyledFormLabel>Option Name *</StyledFormLabel>
          <Input
            placeholder="Option Name"
            value={newOptionData.option}
            onChange={(e) => handleNewOptionDataChange('option', e.target.value)}
          />
        </FormItemContainer>

        <FormItemContainer>
          <StyledFormLabel>Description</StyledFormLabel>
          <Input
            placeholder="Description"
            value={newOptionData.description}
            onChange={(e) => handleNewOptionDataChange('description', e.target.value)}
          />
        </FormItemContainer>

        <FormItemContainer>
          <StyledFormLabel>Price *</StyledFormLabel>
          <FullWidthInputNumber
            placeholder="Price"
            value={newOptionData.price ? parseFloat(newOptionData.price) : undefined}
            onChange={(value) => handleNewOptionDataChange('price', value?.toString() || '')}
            min={0}
            step={0.01}
          />
        </FormItemContainer>

        <FormItemContainer>
          <StyledFormLabel>Image (Optional)</StyledFormLabel>
          {localPreview && (
            <ImagePreviewBox>
              <PreviewImg src={localPreview} alt="option" />
            </ImagePreviewBox>
          )}
          <ImageButtonsRow>
            <Button
              icon={<PictureOutlined />}
              onClick={() => fileInputRef.current?.click()}
              size="small"
            >
              {localPreview ? 'Change Image' : 'Upload Image'}
            </Button>
            {localPreview && (
              <Button icon={<DeleteOutlined />} size="small" danger onClick={handleRemoveImage}>
                Remove
              </Button>
            )}
          </ImageButtonsRow>
          <HiddenFileInput
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </FormItemContainer>
      </FormContainer>

      {cropSrc && (
        <ImageCropModal
          open={!!cropSrc}
          imageSrc={cropSrc}
          aspect={1}
          onCropDone={handleCropDone}
          onCancel={handleCropCancel}
        />
      )}
    </>
  );
};
